// extracted by css-extract-rspack-plugin
export default {"wrapper":"K626yv2MNAmrerBD"};